import React from 'react'

const AdminTags = () => {
  return (
    <div>AdminTags</div>
  )
}

export default AdminTags